import { DIGITAL_WALLETS, DIGITAL_WALLETS_TRACKING_KEY } from 'utils/Money/constants';

/**
 * These maps with available Payment Settings comming from shopify
 * https://shopify.dev/docs/api/storefront/2023-10/enums/DigitalWallet
 *
 * Shopify do not consider Paypal and Amazon Pay as part of the digital wallet enum returned by the API
 */
const DIGITAL_WALLETS_PROPS = {
  [DIGITAL_WALLETS.ANDROID_PAY]: {
    logo: '',
    altText: 'Proceed with Android Pay',
    backgroundColor: '',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.ANDROID_PAY,
  },
  [DIGITAL_WALLETS.GOOGLE_PAY]: {
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/4mz6vy0p8adMSUKkW5qd7p/416938c3e395f691553ab47f0007f8b6/G_Pay.png',
    altText: 'Proceed with Google Pay',
    backgroundColor: '#000000',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.GOOGLE_PAY,
  },
  [DIGITAL_WALLETS.SHOPIFY_PAY]: {
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/6z90ekdLBJdFRPh7vo2wLh/2d4a0a4e96f3d7a19cea75f09cdc59ad/ShopPay_-_White.svg',
    altText: 'Proceed with Shop Pay',
    backgroundColor: '#5a31f4',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.SHOPIFY_PAY,
  },
  [DIGITAL_WALLETS.APPLE_PAY]: {
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/3DDS5hjUEljoau9dxGTHsz/aac3b6efbcbecdfb9c472304e5efa073/Apple_Pay_-_White.svg',
    altText: 'Proceed with Apple Pay',
    backgroundColor: '#000000',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.APPLE_PAY,
  },
  // Paypal is not part of the supported digital wallet enum on version 2023-10, for now is hardcoded
  [DIGITAL_WALLETS.PAY_PAL]: {
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/4dooJgkFpDR0AeMb4MKw8u/954fd7930cbc82523b57ef6e724be215/PayPal_-_Color.svg',
    altText: 'Proceed with PayPal',
    backgroundColor: '#ffc439',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.PAY_PAL,
  },
  // Amazon Pay is not part of the supported digital wallet enum on version 2023-10, for now is hardcoded
  [DIGITAL_WALLETS.AMAZON_PAY]: {
    logo: 'https://images.ctfassets.net/9uo1qvvet3xa/33RudJxATBd104HGRLDee7/b2c410059d5ba3cdef8fcbd4f8a5803c/Amazon_Pay_-_Black.svg',
    altText: 'Proceed with Amazon Pay',
    backgroundColor: '#fad676',
    analyticsKey: DIGITAL_WALLETS_TRACKING_KEY.AMAZON_PAY,
  },
};

export default DIGITAL_WALLETS_PROPS;
